module.exports = __webpack_public_path__ + "static/media/timer.bdb95498.jpeg";